import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import InstallPrompt from '@/components/InstallPrompt';
import DashboardPage from '@/pages/DashboardPage';
import OwnersPage from '@/pages/OwnersPage';
import HuespedesPage from '@/pages/HuespedesPage';
import OwnerDetailPage from '@/pages/OwnerDetailPage';
import LeadsPage from '@/pages/LeadsPage';
import SuscritosPage from '@/pages/SuscritosPage';
import CampanasPage from '@/pages/comunicaciones/CampanasPage';
import CampanaPage from '@/pages/comunicaciones/CampanaPage';
import ContactosComunicacionesPage from '@/pages/comunicaciones/ContactosPage';
import AjustesComunicacionesPage from '@/pages/comunicaciones/AjustesPage';
import ConversacionesPage from '@/pages/comunicaciones/ConversacionesPage';
import PlantillasWhatsAppPage from '@/pages/comunicaciones/PlantillasPage';
import PeticionesPage from '@/pages/PeticionesPage';
import PeticionDetallePage from '@/pages/PeticionDetallePage';
import CandidatosPage from '@/pages/CandidatosPage';
import CandidatoDetallePage from '@/pages/CandidatoDetallePage';
import PersonalLayout from '@/pages/PersonalLayout';
import PersonalPage from '@/pages/PersonalPage';
import PersonalAusenciasPage from '@/pages/PersonalAusenciasPage';
import PersonalFichajesPage from '@/pages/PersonalFichajesPage';
import PersonalVencimientosPage from '@/pages/PersonalVencimientosPage';
import EmpleadoDetallePage from '@/pages/EmpleadoDetallePage';
import PropertiesPage from '@/pages/PropertiesPage';
import PropertyDetailPage from '@/pages/PropertyDetailPage';

import TareasPage from '@/pages/TareasPage';
import ContractsPage from '@/pages/ContractsPage';
import ContratosLayout from '@/pages/contratos/ContratosLayout';
import ContratosListaPage from '@/pages/contratos/ContratosListaPage';
import ContratoEditorPage from '@/pages/contratos/ContratoEditorPage';
import PlantillasPage from '@/pages/contratos/PlantillasPage';
import PlantillaEditorPage from '@/pages/contratos/PlantillaEditorPage';
import SettingsPage from '@/pages/SettingsPage';
import LiquidacionesPage from '@/pages/LiquidacionesPage';
import FacturasPage from '@/pages/FacturasPage';
import CalculadorasPage from '@/pages/CalculadorasPage';
import CalculadoraR2RPage from '@/pages/CalculadoraR2RPage';
import CalculadoraGestionPage from '@/pages/CalculadoraGestionPage';
import CalculadoraOTAPage from '@/pages/CalculadoraOTAPage';
import CalculadoraLuzPage from '@/pages/CalculadoraLuzPage';
import AnalyticsPage from '@/pages/AnalyticsPage';
import PerformancePage from '@/pages/PerformancePage';
import ComparativasPage from '@/pages/ComparativasPage';
import ReviewsLayout from '@/pages/ReviewsLayout';
import ReviewsRankingPage from '@/pages/ReviewsRankingPage';
import ReviewsPlanPage from '@/pages/ReviewsPlanPage';
import ReviewsListingPage from '@/pages/ReviewsListingPage';
import FinanceLayout from '@/pages/FinanceLayout';
import ReservasHistoricoPage from '@/pages/ReservasHistoricoPage';
import CopyLayout from '@/pages/CopyLayout';
import CopyPage from '@/pages/CopyPage';
import CopyPromptsPage from '@/pages/CopyPromptsPage';
import CouponsPage from '@/pages/CouponsPage';
import TuserenoConfigPage from '@/pages/TuserenoConfigPage';
import SerenaPage from '@/pages/SerenaPage';
import AutomatizacionesPage from '@/pages/AutomatizacionesPage';
import AperturasLayout from '@/pages/AperturasLayout';
import LlamadasLayout from '@/pages/LlamadasLayout';
import LlamadasMetricasPage from '@/pages/LlamadasMetricasPage';
import LlamadasListaPage from '@/pages/LlamadasListaPage';
import LlamadasGuardadasPage from '@/pages/LlamadasGuardadasPage';
import CentralitaPage from '@/pages/CentralitaPage';
import AperturasPage from '@/pages/AperturasPage';
import AperturasManualesPage from '@/pages/AperturasManualesPage';
import AperturasSaludPage from '@/pages/AperturasSaludPage';
import AperturasTimbresPage from '@/pages/AperturasTimbresPage';
import ServiciosPage from '@/pages/ServiciosPage';
import GastosPage from '@/pages/GastosPage';
import DispositivosLayout from '@/pages/DispositivosLayout';
import DispositivosInventarioPage from '@/pages/DispositivosInventarioPage';
import DispositivosStockPage from '@/pages/DispositivosStockPage';
import DispositivosIncidenciasPage from '@/pages/DispositivosIncidenciasPage';
import DispositivosAuditoriaPage from '@/pages/DispositivosAuditoriaPage';
import DispositivoDetallePage from '@/pages/DispositivoDetallePage';

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          {/* /leads era la pantalla de leads de propietarios; ahora hay dos, así
              que pasa a redirigir para no romper enlaces guardados. */}
          <Route path="/leads" element={<Navigate to="/leads/propietarios" replace />} />
          <Route path="/leads/propietarios" element={<LeadsPage />} />
          <Route path="/leads/suscritos" element={<SuscritosPage />} />
          {/* Peticiones de propietarios llegadas del wizard de la web. La ruta
              de detalle es la que enlaza el aviso de Telegram. */}
          <Route path="/leads/peticiones" element={<PeticionesPage />} />
          <Route path="/leads/peticiones/:id" element={<PeticionDetallePage />} />
          {/* Las tareas eran una sección de primer nivel en /tasks aunque el
              menú ya las colgara de Leads. Aquí quedan donde se usan. */}
          <Route path="/leads/tareas" element={<TareasPage />} />
          {/* Se llamó /leads/huespedes hasta que quedó claro que ahí no hay
              huéspedes sino suscriptores del portal; se respetan los enlaces. */}
          <Route path="/leads/huespedes" element={<Navigate to="/leads/suscritos" replace />} />
          {/* Bolsa de empleo. Cuelga de «Equipo» y no de Leads: quien manda el
              CV no es un cliente potencial. Debajo, en el mismo grupo, está la
              plantilla ya contratada. */}
          <Route path="/equipo/candidatos" element={<CandidatosPage />} />
          <Route path="/equipo/candidatos/:id" element={<CandidatoDetallePage />} />
          {/* Fichas de los empleados. La ficha va FUERA del layout a propósito:
              en un móvil, sus pestañas más las del layout se comen media
              pantalla antes del primer dato. Igual que el detalle de un
              alojamiento en Reseñas. */}
          <Route path="/equipo/personal" element={<PersonalLayout />}>
            <Route index element={<PersonalPage />} />
            <Route path="ausencias" element={<PersonalAusenciasPage />} />
            <Route path="fichajes" element={<PersonalFichajesPage />} />
            <Route path="vencimientos" element={<PersonalVencimientosPage />} />
          </Route>
          <Route path="/equipo/personal/:id" element={<EmpleadoDetallePage />} />
          <Route path="/owners" element={<OwnersPage />} />
          <Route path="/huespedes" element={<HuespedesPage />} />
          <Route path="/owners/:id" element={<OwnerDetailPage />} />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/properties/new" element={<PropertiesPage />} />
          <Route path="/properties/:id" element={<PropertyDetailPage />} />

          {/* Vivía aquí antes de ser subsección de Leads; se respetan los
              enlaces guardados y los avisos de Telegram ya enviados. */}
          <Route path="/tasks" element={<Navigate to="/leads/tareas" replace />} />
          <Route path="/liquidaciones" element={<LiquidacionesPage />} />
          <Route path="/facturas" element={<FacturasPage />} />
          <Route path="/contabilidad/servicios" element={<ServiciosPage />} />
          <Route path="/contabilidad/gastos" element={<GastosPage />} />
          {/* Contratos: generar desde el CRM, mantener la plantilla y seguir la
              firma. /contracts era solo el seguimiento de Click & Sign; sigue
              existiendo como pestaña Firmas para no romper enlaces. */}
          <Route path="/contracts" element={<ContratosLayout />}>
            <Route index element={<ContratosListaPage />} />
            <Route path="plantillas" element={<PlantillasPage />} />
            <Route path="plantillas/:key/:version" element={<PlantillaEditorPage />} />
            <Route path="firmas" element={<ContractsPage />} />
          </Route>
          <Route path="/contracts/nuevo" element={<ContratoEditorPage />} />
          <Route path="/contracts/c/:id" element={<ContratoEditorPage />} />
          <Route path="/comunicaciones" element={<Navigate to="/comunicaciones/campanas" replace />} />
          <Route path="/comunicaciones/campanas" element={<CampanasPage />} />
          <Route path="/comunicaciones/campanas/:id" element={<CampanaPage />} />
          <Route path="/comunicaciones/conversaciones" element={<ConversacionesPage />} />
          <Route path="/comunicaciones/plantillas" element={<PlantillasWhatsAppPage />} />
          <Route path="/comunicaciones/contactos" element={<ContactosComunicacionesPage />} />
          <Route path="/comunicaciones/ajustes" element={<AjustesComunicacionesPage />} />
          <Route path="/calculadoras" element={<CalculadorasPage />} />
          <Route path="/calculadoras/r2r" element={<CalculadoraR2RPage />} />
          <Route path="/calculadoras/gestion" element={<CalculadoraGestionPage />} />
          <Route path="/calculadoras/ota" element={<CalculadoraOTAPage />} />
          <Route path="/calculadoras/luz" element={<CalculadoraLuzPage />} />
          <Route path="/finance" element={<FinanceLayout />}>
            <Route index element={<AnalyticsPage />} />
            <Route path="performance" element={<PerformancePage />} />
            <Route path="comparativas" element={<ComparativasPage />} />
          </Route>
          {/* Las tres vivían sueltas en el sidebar antes de agruparse bajo
              Finance; se respetan los enlaces guardados. */}
          <Route path="/analytics" element={<Navigate to="/finance" replace />} />
          <Route path="/analytics/reservas" element={<ReservasHistoricoPage />} />
          <Route path="/performance" element={<Navigate to="/finance/performance" replace />} />
          <Route path="/comparativas" element={<Navigate to="/finance/comparativas" replace />} />
          <Route path="/reviews" element={<ReviewsLayout />}>
            <Route index element={<ReviewsRankingPage />} />
            <Route path="plan" element={<ReviewsPlanPage />} />
          </Route>
          {/* El detalle de un alojamiento queda FUERA del layout a propósito: sus
              96 px de cabecera más 44 de pestañas se comen un cuarto de la
              pantalla de un móvil antes de la primera reseña, y aquí lo que se
              viene a hacer es leer. Trae su propia barra de volver. */}
          <Route path="/reviews/l/:listingId" element={<ReviewsListingPage />} />
          {/* La sección se pidió como «Analytics > Reviews» y el sidebar la
              agrupa bajo Analytics, así que ese camino tiene que llevar a algún
              sitio. Igual con el nombre que tenía el plan antes de llamarse así. */}
          <Route path="/analytics/reviews" element={<Navigate to="/reviews" replace />} />
          <Route path="/reviews/mejoras" element={<Navigate to="/reviews/plan" replace />} />
          <Route path="/copy" element={<CopyLayout />}>
            <Route index element={<CopyPage />} />
            <Route path="prompts" element={<CopyPromptsPage />} />
          </Route>
          <Route path="/tusereno/cupones" element={<CouponsPage />} />
          <Route path="/tusereno/configuracion" element={<TuserenoConfigPage />} />
          <Route path="/tusereno/serena" element={<SerenaPage />} />
          <Route path="/automatizaciones" element={<AutomatizacionesPage />} />
          <Route path="/centralita" element={<CentralitaPage />} />
          <Route path="/llamadas" element={<LlamadasLayout />}>
            {/* El listado es la portada: se entra aquí a buscar una llamada
                concreta mucho más a menudo que a mirar los agregados. */}
            <Route index element={<LlamadasListaPage />} />
            <Route path="metricas" element={<LlamadasMetricasPage />} />
            <Route path="guardadas" element={<LlamadasGuardadasPage />} />
            {/* Estuvo aquí un rato; ahora es sección propia. */}
            <Route path="centralita" element={<Navigate to="/centralita" replace />} />
            {/* La lista vivía aquí antes de ser la portada; se respetan los enlaces guardados. */}
            <Route path="listado" element={<Navigate to="/llamadas" replace />} />
          </Route>
          <Route path="/aperturas" element={<AperturasLayout />}>
            <Route index element={<AperturasPage />} />
            <Route path="manuales" element={<AperturasManualesPage />} />
            <Route path="salud" element={<AperturasSaludPage />} />
            <Route path="timbres" element={<AperturasTimbresPage />} />
          </Route>
          {/* La ficha va fuera del layout, como la de un empleado: en el
              móvil, cabecera más pestañas más las de la ficha son media pantalla. */}
          <Route path="/dispositivos" element={<DispositivosLayout />}>
            <Route index element={<DispositivosInventarioPage />} />
            <Route path="stock" element={<DispositivosStockPage />} />
            <Route path="incidencias" element={<DispositivosIncidenciasPage />} />
            <Route path="auditoria" element={<DispositivosAuditoriaPage />} />
          </Route>
          <Route path="/dispositivos/:id" element={<DispositivoDetallePage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </Layout>
      <InstallPrompt />
    </BrowserRouter>
  );
}
